var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRingSucess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.9375C10.4302 3.9375 11.84 4.27598 13.1143 4.92525C14.3886 5.57453 15.4911 6.51617 16.3317 7.6732C17.1723 8.83022 17.7272 10.1698 17.9509 11.5823C18.1747 12.9949 18.0609 14.4403 17.619 15.8005C17.177 17.1606 16.4194 18.3969 15.4082 19.4082C14.3969 20.4194 13.1606 21.177 11.8005 21.6189C10.4403 22.0609 8.99486 22.1747 7.58232 21.9509C6.16977 21.7272 4.83022 21.1723 3.6732 20.3317",
    stroke: "#75E0A7",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingSucess);
export default __webpack_public_path__ + "static/media/ring_sucess.dd637cf7213ddeed0d922b9cc8b0faa1.svg";
export { ForwardRef as ReactComponent };